import React from 'react';
import { useLocation } from 'react-router';
import { SettingAccountItemProviderConfig } from '../../../../../route';
import { SettingSubscriptionConfig } from '../subscriptionConfig';
import {
    SettingSubscriptionEditController,
    SettingSubscriptionEditDeps,
    SettingSubscriptionEditLoader,
} from './editInterface';
import { SettingSubscriptionEditContainerProps } from './editProps';

export function createSettingSubscriptionEditContainer(
    init: Pick<SettingSubscriptionConfig, 'form' | 'infra' | 'service' | 'repository'>,
    config: Pick<SettingAccountItemProviderConfig, 'api'>,
    loader: SettingSubscriptionEditLoader,
    controller: SettingSubscriptionEditController
): React.FC<SettingSubscriptionEditContainerProps> {
    const {
        infra: { toaster },
        service: {
            subscription: { useUpdate },
        },
        form: {
            subscription: { edit: editForm },
        },
        repository: { method },
    } = init;
    const {
        api: { useContext },
    } = config;

    return ({ as: Component, children, ...props }) => {
        const viewContext = useContext();
        const viewData = loader.useLoad(viewContext);
        const viewDeps: SettingSubscriptionEditDeps = {
            edit: {
                location: useLocation(),
                form: editForm.useForm(viewContext, viewData),
                mutation: {
                    method: {
                        portal: method.usePortal(viewContext),
                    },
                    update: useUpdate(viewContext, viewData),
                },
            },
            toast: toaster.useToast(),
        };
        const viewProps = controller.useProps(viewContext, viewDeps, { item: viewData });
        return <Component {...viewProps}>{children}</Component>;
    };
}
